module.exports = __webpack_public_path__ + "files/f8d9c9020db5e23fa78b59c275f21bdb.png";